import grapesjs from 'drapcode-builder';
import loadComponents from './components';
import loadBlocks from './blocks';
import { colFormRef } from './consts';

export default grapesjs.plugins.add('gjs-sign-up-form', (editor, opts) => {
  let c = opts || {};

  let defaults = {
    pfx: 'sign-up-form',
    blocks: [colFormRef],
    defaultStyle: true,
    labelColForm: 'Sign Up Form',
    labelColFormCategory: 'Forms',
    labelTraitMethod: 'Method',
    labelTraitAction: 'Action',
    labelColName: 'Collection',
  };

  for (let name in defaults) {
    if (!(name in c)) c[name] = defaults[name];
  }

  loadComponents(editor, c);
  loadBlocks(editor, c);
});
